module.exports = __webpack_public_path__ + "images/163ec5e8.main-pic-kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/main-pic-kor.png
// module id = 392
// module chunks = 0